// extracted by mini-css-extract-plugin
export default {"moderationNotesContainer":"moderationNotesContainer__F7dfE","moderationHeader":"moderationHeader__n8Cne","moderationText":"moderationText__pLE9B"};